import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/seeker/components/single-page-registration/index.tsx");
